import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';

import { Injectable } from '@angular/core';
import { DoceboToken } from '@app/models/docebo-token.model';
import { AuthService } from '@app/services/user/auth/auth.service';
import { environment } from '@environments/environment';

@Injectable()
export class DoceboAuthorizerInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  /**
   * Intercept Docebo API to set Docebo Access Token
   * @inheritdoc
   *
   * Filters requested urls with String.prototype.startsWith to ensure
   * subpaths do not affect this interceptor.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // NOTE: Update URL for any specific apis that require Okta access token in the future
    const urlToMatch = `${environment.docebo.url}`;

    let accessToken: string;
    firstValueFrom(this.authService.getDoceboAccessToken()).then((doceboToken: DoceboToken) => {
      accessToken = doceboToken?.access_token;
    });

    if (accessToken && request.url.startsWith(urlToMatch)) {
      const clone = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
      return next.handle(clone);
    } else {
      return next.handle(request);
    }
  }
}
